import { StandardEvents } from '@shopify/events';

/**
 * Haelt die UVP-Zeile unter dem Preis beim Variantenwechsel aktuell.
 *
 * Der Wert liegt im Variantenmetafeld prodex.uvp. Horizon morpht beim
 * Variantenwechsel nur den Varianten-Waehler, die Zeile wuerde also den Betrag
 * der zuvor gewaehlten Variante behalten. Dasselbe Problem loest
 * assets/buechel-spec-table.js weiter unten auf der Seite ueber die Section
 * Rendering API — hier reicht der kuerzere Weg: die Betraege aller Varianten
 * stehen bereits im data-Attribut, umgeschaltet wird ohne Netzzugriff.
 */
class BuechelUvp extends HTMLElement {
  #werte = {};
  #ziel = null;

  connectedCallback() {
    try {
      this.#werte = JSON.parse(this.dataset.werte || '{}');
    } catch (fehler) {
      console.warn('[buechel-uvp] Werte nicht lesbar:', fehler);
      this.#werte = {};
    }

    const ziel = this.closest('[id*="ProductInformation-"], [id*="QuickAdd-"]');
    (ziel || document).addEventListener(StandardEvents.productSelect, this.#beiVariantenwechsel);
    this.#ziel = ziel || document;
  }

  disconnectedCallback() {
    this.#ziel?.removeEventListener(StandardEvents.productSelect, this.#beiVariantenwechsel);
  }

  #beiVariantenwechsel = (event) => {
    if (event.target instanceof Element && event.target.closest('product-card, quick-add-dialog')) return;

    Promise.resolve(event.promise)
      .then(({ detail } = {}) => {
        const variantenId = detail?.resource?.id;
        if (!variantenId) return;
        this.#anzeigen(this.#werte[String(variantenId)]);
      })
      .catch((fehler) => {
        if (fehler?.name !== 'AbortError') console.warn('[buechel-uvp]', fehler);
      });
  };

  #anzeigen(betrag) {
    const text = this.querySelector('[data-ref="text"]');
    if (!text) return;

    if (betrag) {
      text.textContent = `${this.dataset.bezeichnung || 'UVP'} ${betrag}`;
      this.style.display = '';
    } else {
      text.textContent = '';
      this.style.display = 'none';
    }
  }
}

if (!customElements.get('buechel-uvp')) {
  customElements.define('buechel-uvp', BuechelUvp);
}
